export default __webpack_public_path__ + "static/media/check-circle-primary.ff8f824a.svg";